<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    <mega-store-factory-sidebar></mega-store-factory-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="toggle" (click)="toggleSidenav()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="top_header_ryt">
        <!-- <mat-slide-toggle [(ngModel)]="toggleValue" (change)="toggleOnlineOffline()">{{
          toggleValue ? 'Online' : 'Offline'
        }}</mat-slide-toggle> -->
        <!-- Language Switcher -->
        <div class="lang_switch" mat-button [matMenuTriggerFor]="languageMenu">
          <i class="fa fa-globe" aria-hidden="true"></i>
          <span class="lang_code">{{ currentLanguage | uppercase }}</span>
        </div>

        <mat-menu #languageMenu="matMenu" yPosition="below" class="dropdown dropbox">
          <ul class="hd_menu">
            <li
              *ngFor="let language of languages"
              [class.active]="language.code === currentLanguage"
              (click)="changeLanguage(language.code)">
              {{ language.label }}
            </li>
          </ul>
        </mat-menu>

        <figure mat-button [matMenuTriggerFor]="belowMenu">
          <img [src]="image || assetsConst.profileLogo" alt="profile" />
        </figure>
        <mat-menu
          #belowMenu="matMenu"
          yPosition="below"
          class="dropdown dropbox">
          <ul class="hd_menu">
            <li routerLink="/profile/view-profile">
              <figure>
                <img [src]="assetsConst.userLogo" alt="profile" />
              </figure>
              {{ 'MyProfile' | translate }}
            </li>
            <li routerLink="/password/change-paswd">
              <figure>
                <img [src]="assetsConst.passwordLogo" alt="profile" />
              </figure>
              {{ 'ChangePassword' | translate }}
            </li>
            <li (click)="logout()">
              <figure>
                <img [src]="assetsConst.logoutLogo" alt="profile" />
              </figure>
              {{ 'Logout' | translate }}
            </li>
          </ul>
        </mat-menu>
      </div>
    </div>
    <main class="main_wrapper">
      <router-outlet></router-outlet>
    </main>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>